import React, { useState, useRef, useEffect } from 'react';
import styles from './index.module.scss';
import Header from '../components/header';
import { Dropdown, List, Toast } from 'antd-mobile-v5';
import { DownOutline, MessageOutline } from 'antd-mobile-icons';
import EPROInterviewList from './components/interviewList';
import EPROQuantitative from './components/quantitative';
import { ApiCore } from '../../api';
import { ToastHandler } from 'antd-mobile-v5/es/components/toast';
import ChatModal from '../../component/chat/ChatModal';
import { messageUnreadCount } from '../../api/chat';
import { Modal } from 'antd-mobile';

const EPROHome = (props: any) => {
    const api = new ApiCore();

    // api.getReportRecodProject({}).then(res => {
    // })
    const [ subjectDetail, setSubjectDetail ] = useState<any>({})
    const [ project, setProject ] = useState<any>({})
    const [ subject, setSubject ] = useState<any>({})
    const [ visit, setVisit ] = useState<any>({})
    const [ projectList, setProjectList ] = useState<any[]>([])
    const [ interviewList, setInterviewList] = useState<any[]>([])
    const [ scaleList, setScaleList] = useState<any[]>([])
    const cacheable = useRef<boolean>(false)

    const projectDropdownRef = useRef(null)

     // 显示聊天弹窗
     const [showChatModal, setShowChatModal] = useState(false)
     const [unread, setUnread] = useState(0)

    const handleProjectClick = (item: any) => {
        setVisit([])
        setInterviewList([])
        setScaleList([])
        sessionStorage.setItem('epro_project', JSON.stringify(item || {}))
        sessionStorage.removeItem('epro_visit_index')
        setProject(item);
        (projectDropdownRef?.current as any)?.close();
        loadSuject(item.projectCode)
    }

    const handleSelectVisit = (item: any) => {
        
        setVisit(item)
        loadScale(item.id)
    }
    
    let loadingToast: ToastHandler | null = null

    const init = async () => {
        await loadReportProjects();
    }
    const loadReportProjects = async () => {
        initLoading()
        try {
            const { data, code } = await api.getReportRecodProject({})
            setProjectList(data || [])
            if (Number(code) === 0 && data?.length > 0) {
                const projectCacheStr = sessionStorage.getItem('epro_project')
                let projectCodeQuery = new URLSearchParams(props.location.search).get('projectCode') as string
                let currentProject = data[0]
                let projectCode = currentProject.projectCode
                if (projectCacheStr) {
                    try {
                        const projectCache = JSON.parse(projectCacheStr)
                        projectCode = projectCache.projectCode
                    } catch (error) {
                        
                    }
                } else if (projectCodeQuery) {
                    projectCode = projectCodeQuery
                }
                const projectItem = data.find((item: any) => item.projectCode === projectCode)
                if (projectItem) {
                    currentProject = projectItem
                }
                sessionStorage.setItem('epro_project', JSON.stringify(currentProject || {}))
                setProject(currentProject);
                loadSuject(currentProject?.projectCode);
            } else {
                clearLoadig()
                props.history.push('/epro/patient/tourist')
            }
            return
        } catch (error) {
            clearLoadig()
        }
        setProject({})
        setSubject({})
        setInterviewList([])
        setScaleList([])
    }

    const loadSuject = async (projectCode: string) => {
        initLoading()
        try {
            const { data, code } = await api.getSubjectList({ projectCode })
            if(Number(code) === 0 && data?.length > 0) {
                setSubject(data[0] || {})
                await loadVisitList(data[0]?.subjectCode);
                return
            } else {
                clearLoadig()
            }
        } catch (error) {
            clearLoadig()
        }
        setSubject({})
        setInterviewList([])
        setScaleList([])
    }

    const loadVisitList = async (subjectCode: any) => {
        try {
            const { data, code } = await api.getSubjectdDetail({ id: subjectCode })
            setSubjectDetail(data)
            if (Number(code) === 0 && data?.visits?.length > 0) {
                if(data?.editModel === 1){
                    data.visits = data.visits.filter((e:any)=>e.scaleNum)
                }
                setInterviewList(data.visits)
                const indexCache = sessionStorage.getItem("epro_visit_index")
                let currentVisit;
                // 有缓存值优先取缓存值
                if(indexCache){
                    currentVisit = data.visits[indexCache]
                }else{
                    currentVisit = data.visits.find((item: any) => ['Wait', 'Running'].includes(item.state)) || data.visits[0]
                }
                setVisit(currentVisit)
                if(currentVisit) {
                    await loadScale(currentVisit?.id);
                }
                clearLoadig()
                return
            } else {
                clearLoadig()
            }
        } catch (error) {
            clearLoadig()
        }
        setInterviewList([])
        setScaleList([])
    }

    const loadScale = async (id: string) => {
        try {
            const { data, code } = await api.getFormsById({ id })
            clearLoadig()
            if (Number(code) === 0) {
                setScaleList((data?.scales || []))
                
                await loadScaleRecordCount(data?.scales || [])
                return
            } 
        } catch (error) { 
            clearLoadig()
        }
        setScaleList([])
    }

    const loadScaleRecordCount = async (scales: any[]) => {
        try {
            const { data, code } = await api.getScaleRecordCount({
                scaleIds: scales.map(item => item.id).join(',')
            })
            if (Number(code) === 0) {
                const newScales = scales.map(item => {
                    return {
                        ...item,
                        count: data.find((countItem: { scaleId: number, count: number}) => item.id === countItem.scaleId)?.count || 0
                    }
                })
                console.log(newScales, 'newScales')
                if(newScales?.length){
                    sessionStorage.setItem("scalesList", JSON.stringify(newScales))
                }
              
                setScaleList(newScales)
            }
        } catch (error) {
            
        }
    }

    const handleReport = async (item: any) => {
        
        cacheable.current = true
        let recordId = ''
        try {
           const { data, code } = await api.getScaleRecord({ scaleId: item.id })
           if (Number(code) === 0) {
            recordId = data?.scalaServerRecordId || ''
           }
        } catch (error) {
        }
        if(subjectDetail?.editModel === 1 && item.reportState === 1){
            props.history.push(`/epro/patient/reportSurvey?recordId=${recordId||'default'}&scaleCode=${item.code||''}`);
        }else{
            props.history.push(`/epro/patient/evaluation?arrival=${item.arrival}&recordId=${recordId||'default'}&scaleId=${item.id||''}&scaleCode=${item.code||''}&scaleName=${item.name||''}&subjectCode=${subject.subjectCode||''}&backUrl=${props.history.location.pathname}/`);
        }
    }

    const destroy = ()=> {
        clearLoadig()
        if (!cacheable) {
            sessionStorage.removeItem('epro_project')
        }
    }
    
    useEffect(() => {
        document.title = '首页'
        init()
        return destroy
    }, [])

    useEffect(() => {
        clearLoadig()
    })

    // 未读消息轮询
    useEffect(()=> {
        if (!subjectDetail || subjectDetail.editModel === 0) {
            return
        }
        const timer = setInterval(async ()=> {
           if (showChatModal) {
               return
           }
           const subjectCode = subjectDetail.code
           const {code, data} = await messageUnreadCount({
            subjectCode
           })
           if(code === 0) {
             setUnread(data[subjectCode])
           }
        }, 3000)
        return ()=> {
            clearInterval(timer)
        }
    }, [subjectDetail, showChatModal])

    const clearLoadig = () => {
        loadingToast?.close()
        loadingToast = null
    }

    const initLoading = () => {
        if (loadingToast) {
            clearLoadig()
        }
        loadingToast = Toast.show({
            icon: 'loading',
            content: '加载中...',
            duration: 0
        })
    }

    const n2url = ()=> {
        if(typeof window.wx.miniProgram.navigateTo === 'function') {
            window.wx.miniProgram.navigateTo({
                url: `/pages/preview/index?urls=${subjectDetail.agreementUrl}`,
                success() {
                },
                fail() {
                    Modal.alert('提示', '下载文件失败')
                }
            })
        } else {
            Modal.alert('提示', '请在小程序打开')
        }
    }

    const suffix = <button onClick={n2url} className={styles.suffix}>知情同意书</button>

    return (
        <div className={styles.eproHome}>
            <Header suffix={subjectDetail.signatureState === 3 ? suffix : null} name={project.projectName} secondName={subject?.subjectCode} title={`欢迎${subject?.reportName || ''}加入`}></Header>
           
            <div className={styles.proejctDropdown}>
                <Dropdown arrow={<DownOutline style={{color: '#fff', fontSize: '14px'}}/>} ref={projectDropdownRef}>
                    <Dropdown.Item key='project' title='切换项目'>
                        <List>
                            {projectList?.map(item => (
                                <List.Item key={item.projectCode} onClick={() => { handleProjectClick(item) }}>{item.projectName}</List.Item>
                            ))}
                        </List>
                    </Dropdown.Item>
                </Dropdown>
            </div>
            <div className={styles.homeContent}>
                <EPROInterviewList list={interviewList} onSelect={handleSelectVisit}></EPROInterviewList>
                {
                    scaleList?.length > 0 ? (
                        <div className={styles.quantList}>
                            {
                                scaleList.map(item => (
                                    <EPROQuantitative
                                        editModel={subjectDetail?.editModel}
                                        key={item.id}
                                        code={item.code}
                                        name={item.name}
                                        state={item.reportState}
                                        count={item.count || 0}
                                        questionCount={item.scaleTopicCount || 0}
                                        time={item.scalePlannedTime}
                                        item={item}
                                        visit={visit}
                                        subjectCode={subject.subjectCode}
                                        onReport={() => handleReport(item)}
                                    ></EPROQuantitative>
                                ))
                            }
                        </div>
                    ) : ''
                }
            </div>
            {
                subjectDetail?.editModel === 1 && interviewList.length > 0 && (
                    <button type="button" className={styles.chat} onClick={(event)=> {
                        event.stopPropagation()
                        setShowChatModal(true)
                    }}>
                        <MessageOutline/>
                        {unread > 0 && <i>{unread}</i>}
                    </button>
                )
            }
            {/* 聊天窗口 */}
            {
                showChatModal && (
                    <ChatModal fromDoctor={false} subjectCode={subject?.subjectCode} onClose={()=> setShowChatModal(false)}/>
                )
            }
        </div>
    )
}

export default EPROHome